
import { useSelector } from "react-redux";

const useHasEditPermission = (permissionValue) => {  
    const applicationEditPermission = useSelector((state) => state.permission.applicationPermission);
  
    const hasEditPermission = applicationEditPermission.includes(permissionValue);

    return hasEditPermission;
};

export default useHasEditPermission;
